import React from "react";
var __jsx = React.createElement;
import { useRouter } from "next/router";
import { useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import useApp from "hooks/useApp";
import Analytics from "services/adobeAnalytics";
import { AppContext, STATUSVALUES } from "contexts/appContext";
import useMount from "hooks/useMount";
import { selectUsersession, fetchUsersession } from "redux/reducers/userSessionReducer";
import { fetchSearchHistory } from "redux/reducers/searchHistoryReducer";
import { fetchFolders } from "redux/reducers/folderStateReducer";
import { fetchSavedSearches } from "redux/reducers/savedSearchesReducer";
import { fetchBaskets } from "redux/reducers/basketStateReducer";
import { initializeSessionSettings } from "redux/reducers/sessionSettingsReducer";
import extractCookieCategories from "components/common/utils/ExtractCookieCategories";
import DefaultSkeleton from "components/fragments/global/DefaultSkeleton";
import useExternalScripts from "./useExternalScripts";
import { validateDbEntitlements } from "./tools";
import { fetchTemporaryEntitlements } from "./temporaryEntitlements";
var AuthenticatedRoute = function AuthenticatedRoute(_ref) {
  var _userSession$user2;
  var isPublic = _ref.isPublic,
    children = _ref.children,
    Skeleton = _ref.skeleton;
  var router = useRouter();
  var usersessionState = useSelector(selectUsersession);
  var _useContext = useContext(AppContext),
    appStatus = _useContext.status;
  var isMounted = useMount();
  var dispatch = useDispatch();
  var userSession = usersessionState === null || usersessionState === void 0 ? void 0 : usersessionState.data;
  useExternalScripts(userSession);
  fetchTemporaryEntitlements();
  // Adobe Analytics related Cookies can be triggered only conditionally based on the user's cookie preferences
  // Public facing pages like dvp don't need to worry about cookies
  var docCookie = typeof document !== "undefined" && document.cookie;
  var cookieCategories = [];
  if (docCookie !== false && !isPublic) {
    cookieCategories = extractCookieCategories(docCookie);
  }
  if (cookieCategories.includes("Performance") && cookieCategories.includes("Functional")) {
    // start adobe and mouseflow
    useApp(Analytics.init);
  }

  // Get userSession and history on Mount
  useEffect(function () {
    if (isPublic || usersessionState.status !== "init") return;
    dispatch(fetchUsersession());
    dispatch(fetchSearchHistory());
  }, [isPublic, usersessionState.status]);
  useEffect(function () {
    var _userSession$user;
    if (usersessionState.status !== "done") return;
    dispatch(initializeSessionSettings(userSession));
    // load state from legacy app and Oracle data for registered users
    if ((userSession === null || userSession === void 0 ? void 0 : (_userSession$user = userSession.user) === null || _userSession$user === void 0 ? void 0 : _userSession$user.associationType) !== "GUEST") {
      if (validateDbEntitlements(userSession.userEntitlements)) {
        dispatch(fetchBaskets());
        dispatch(fetchFolders(userSession));
        dispatch(fetchSavedSearches(userSession));
      } else {
        // send user to server db entitlements error message
        window.location = "/system/error.url?dberrormsg=true";
      }
    }
  }, [usersessionState.status, userSession, dispatch]);
  if (typeof window !== "undefined" && usersessionState.status === "needauth") {
    window.location = "/rest/public/login";
  }
  if (!isPublic && (userSession === null || userSession === void 0 ? void 0 : (_userSession$user2 = userSession.user) === null || _userSession$user2 === void 0 ? void 0 : _userSession$user2.associationType) === "GUEST") {
    router.replace("/home");
  }
  if (Skeleton && appStatus !== STATUSVALUES.DONE) {
    return /*#__PURE__*/React.createElement(Skeleton, null);
  }
  if (appStatus === STATUSVALUES.INITIALIZING_SESSION) {
    return /*#__PURE__*/React.createElement(DefaultSkeleton, null);
  }
  if (!isMounted) {
    // Check the state before Mounting here
    return undefined;
  }
  return children;
};
export default AuthenticatedRoute;